(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template-gc"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });

  });

  } catch(e) { console.error(e); }
})();
})();
